const isNativeEnv = () => {
  return typeof window.Mobile !== 'undefined'
}

const submitMessage = (action, payload) => {
  if (isNativeEnv()) {
    window.Mobile.postMessage(JSON.stringify({ action, payload }))
  }
}

export { isNativeEnv, submitMessage }
